import { useEffect, useMemo } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { getOrcaCustomerValues } from '../actions';

/**
 * Data provider for Canadian payment method update, retrieving
 * ids from Orca database (feed with figo ids).
 */
const usePaymentManagement = ({ policyIdFigo }) => {
  const dispatch = useDispatch();
  const store = useSelector(({
    billingPayments,
  }) => ({ billingPayments }), shallowEqual);

  useEffect(() => {
    if (policyIdFigo) {
      dispatch((getOrcaCustomerValues({ PolicyId: policyIdFigo })));
    }
  }, [policyIdFigo, dispatch]);

  const paymentManagement = useMemo(() => {
    const { billingPayments: { updatePaymentMethodCa } } = store;
    const response = {
      customerId: 0,
      isSyncPaymentMethod: false,
      loadingMonerisTicket: false,
      monerisTicket: '',
      monerisTicketError: null,
      paymentManagementUrl: '',
      paymentMethodError: '',
      paymentMethodLoading: false,
      policyId: 0,
      updated: false,
    };

    // or any other validation from backend response...
    if (!updatePaymentMethodCa?.policyId) {
      return response;
    }

    response.customerId = updatePaymentMethodCa.customerId;
    response.loadingMonerisTicket = updatePaymentMethodCa.loadingMonerisTicket;
    response.monerisTicket = updatePaymentMethodCa.monerisTicket;
    response.monerisTicketError = updatePaymentMethodCa.monerisTicketError;
    response.paymentManagementUrl = updatePaymentMethodCa.paymentManagementUrl;
    response.paymentMethodLoading = updatePaymentMethodCa.paymentMethodLoading;
    response.policyId = updatePaymentMethodCa.policyId;
    response.isSyncPaymentMethod = updatePaymentMethodCa.isSyncPaymentMethod;
    response.updated = updatePaymentMethodCa.updated;
    response.paymentMethodError = updatePaymentMethodCa.paymentMethodError;

    return response;
  }, [store.billingPayments]);

  return paymentManagement;
};

export { usePaymentManagement };
